import { render } from "./InfoBoxComponent.vue?vue&type=template&id=5bf43a6e&scoped=true"
import script from "./InfoBoxComponent.vue?vue&type=script&lang=js"
export * from "./InfoBoxComponent.vue?vue&type=script&lang=js"

import "./InfoBoxComponent.vue?vue&type=style&index=0&id=5bf43a6e&scoped=true&lang=css"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf43a6e"]])

export default __exports__